import { render, staticRenderFns } from "./PoItemUpdate.vue?vue&type=template&id=893436d4&"
import script from "./PoItemUpdate.vue?vue&type=script&lang=js&"
export * from "./PoItemUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports